var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "horizontal-input" },
    _vm._l(_vm.arr, function (item, index) {
      return _c("span", [
        item ? _c("span", [_vm._v(_vm._s(item))]) : _vm._e(),
        index < _vm.arr.length - 1
          ? _c(
              "span",
              {
                staticClass: "span-input",
                attrs: { contenteditable: "true" },
                on: {
                  input: function ($event) {
                    return _vm.onInput($event, index)
                  },
                  keydown: _vm.onSpanInput,
                },
              },
              [_vm._v(" " + _vm._s(_vm.value[index]) + " ")]
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }